'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { PureComponent } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { pick } from 'underscore';
import UIList from 'UIComponents/list/UIList';
import FileModel from 'DesignData/models/finder/File';
import FileResultItem from 'DesignFinderUI/components/results/FileResultItem';
import FileResultsEmptyText from 'DesignFinderUI/components/results/FileResultsEmptyText';
import FileResultsLoading from 'DesignFinderUI/components/results/FileResultsLoading';
export default class FileResultsList extends PureComponent {
  renderResults({
    asLinks,
    children,
    itemComponent: Item,
    itemProps,
    results
  }) {
    if (children) {
      return children;
    }

    return results.map(__file => {
      let fileProps = Object.assign({}, __file);

      if (__file instanceof FileModel) {
        // These props are overriden by getters
        // See DesignData/models/finder/File
        fileProps = Object.assign({}, fileProps, {
          fileId: __file.id,
          fileType: __file.type,
          folderPath: __file.folderPath
        });
      }

      return /*#__PURE__*/_createElement(Item, Object.assign({}, itemProps, {}, fileProps, {
        asLink: asLinks,
        key: __file.id
      }));
    });
  }

  render() {
    const _this$props = this.props,
          {
      asLinks,
      childClassName,
      children,
      className,
      isFetching,
      itemComponent,
      itemProps,
      results,
      total,
      resultsRenderer,
      activeId
    } = _this$props,
          rest = _objectWithoutPropertiesLoose(_this$props, ["asLinks", "childClassName", "children", "className", "isFetching", "itemComponent", "itemProps", "results", "total", "resultsRenderer", "activeId"]);

    if (isFetching) {
      return /*#__PURE__*/_jsx(FileResultsLoading, {});
    }

    if (isFetching === false && !total) {
      return /*#__PURE__*/_jsx(FileResultsEmptyText, Object.assign({}, rest));
    }

    const listClasses = classNames('file-results__list', className);
    const listChildClasses = classNames('file-results__list-item', childClassName);
    const renderer = resultsRenderer || this.renderResults;
    const renderedResults = renderer({
      asLinks,
      children,
      itemComponent,
      itemProps,
      results,
      activeId
    });
    return /*#__PURE__*/_jsx(UIList, Object.assign({}, pick(rest, Object.keys(UIList.propTypes)), {
      childClassName: listChildClasses,
      className: listClasses,
      children: renderedResults
    }));
  }

}
FileResultsList.displayName = 'FileResultsList';
FileResultsList.propTypes = {
  asLinks: PropTypes.bool,
  childClassName: PropTypes.string,
  children: PropTypes.node,
  className: PropTypes.string,
  isFetching: PropTypes.bool,
  itemComponent: PropTypes.object,
  itemProps: PropTypes.object,
  results: PropTypes.array,
  total: PropTypes.number,
  resultsRenderer: PropTypes.func,
  activeId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
FileResultsList.defaultProps = {
  asLinks: true,
  childClassName: '',
  children: null,
  className: '',
  isFetching: null,
  itemComponent: FileResultItem,
  itemProps: {},
  results: []
};